import { createGuidedClient, type GuidedClient } from './guidedClient';
import { useDeploymentStore } from '@/store/deploymentStore';
import { useSubscriptionStore } from '@/store/subscriptionStore';
import { getDeviceId } from '@/utils/deviceId';
import { CognitoService } from '@/auth/CognitoService';

let client: GuidedClient | null = null;

/** The guided client wired to real config/identity/credit-sink. Rebuilt lazily. */
export function guided(): GuidedClient {
  if (client) return client;
  // Prefer the dedicated LLM Function URL (no API Gateway 29s cap — app builds run ~20-60s).
  // Falls back to the API Gateway base if the Function URL isn't configured.
  const baseUrl = (process.env.EXPO_PUBLIC_LLM_URL ?? useDeploymentStore.getState().config?.apiBaseUrl ?? '').replace(/\/+$/, '');
  client = createGuidedClient({
    baseUrl,
    getToken: () => CognitoService.getAccessTokenSync(),
    getDeviceId,
    onCredits: (c) => useSubscriptionStore.getState().setCredits(c),
    onTier: (t) => useSubscriptionStore.getState().setTier(t),
  });
  return client;
}

/** Drop the cached client (e.g. after config changes). */
export function resetGuided(): void { client = null; }
